import BatchSetMessagesModal from './batch-set-messages-modal.vue'
export default BatchSetMessagesModal
